import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";
import H2 from "../../shared/h2";
import { sendCustomGaEvents } from "../../../tracking";
import { vrnEntered, vrnChanged } from "./tracking";
import InputRegNoPlate from "../../shared/input-reg-no-plate";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import EChallanCount from "../e-challan-count";
import EChallanRegNoList from "../e-challan-reg-no-list";
import { Button } from "@cars24/turbo-web/lib/button";
import { NUMBER } from "../../../constants/app-constants";

const EChallanRegNo = ({
    isLoading = false,
    isModal = false,
    history,
    regNo,
    setRegNoConnect = () => {},
    handleClick = () => {},
    isChallanRevamp = false,
    challanCountData = {},
    regChangeEnabled = false,
    isLoggedIn = false,
    regNumberList = [],
    hideCount = false
}) => {
    const regNoRef = useRef(regNo || "");
    const [isError, setIsError] = useState(false);
    const [isValidInput, setIsValidInput] = useState(false);

    useEffect(() => {
        if (isModal) regNoRef.current = "";
    }, [isModal]);

    const registrationNumberValidator = (v) => {
        return isValidRegistrationNo(v.replace(/\s/g, ""));
    };

    const handleOnChange = (val) => {
        regNoRef.current = val.toUpperCase();
        setIsValidInput(registrationNumberValidator(val.toUpperCase()));
        setIsError(false);
    };

    const onClick = async (e, inputRegNo, bypassInputValidation = false) => {
        const finalRegNo = inputRegNo ? inputRegNo : regNoRef.current;
        if (registrationNumberValidator(finalRegNo) && (bypassInputValidation || isValidInput)) {
            setIsError(false);
            setRegNoConnect(finalRegNo);
            if (isModal) {
                await yieldToMain();
                sendCustomGaEvents({
                    ...vrnChanged,
                    eventLabel: finalRegNo
                });
                handleClick(finalRegNo);
            } else {
                await yieldToMain();
                sendCustomGaEvents({
                    ...vrnEntered,
                    eventLabel: `${finalRegNo}, Logged In: ${isLoggedIn}`
                });
                await yieldToMain();
                history.push("/my-challans");
            }
        } else {
            setIsError(true);
        }
    };

    const updateRegNumber = (e, inputRegNo) => {
        regNoRef.current = inputRegNo;
        onClick(e, inputRegNo, true);
    };

    return (
        <div styleName={`styles.bannerWrapper`}>
            <H2 text="Enter vehicle number" />
            <div styleName={`styles.registrationWrapper`}>
                <InputRegNoPlate
                    ref={regNoRef}
                    isError={isError}
                    onChange={handleOnChange}
                    errorMessage={"Please enter a valid vehicle number"}
                    isChallan={isChallanRevamp}
                    maxLength={NUMBER.FIFTEEN}
                />
                {(isChallanRevamp || regChangeEnabled) && regNumberList.length > 0 &&
                    <EChallanRegNoList
                        updateRegNumber={updateRegNumber}
                        regNumberList={regNumberList}
                        isError={isError}
                    />
                }

                <Button
                    label={"Get challan details"}
                    onClick={onClick}
                    isLoading={isLoading}
                    size="large"
                />
            </div>
            {isChallanRevamp && !hideCount && <EChallanCount challanCountData={challanCountData} />}
        </div>
    );
};

EChallanRegNo.propTypes = {
    isLoading: PropTypes.bool,
    isModal: PropTypes.bool,
    history: PropTypes.object,
    regNo: PropTypes.string,
    setRegNoConnect: PropTypes.func,
    handleClick: PropTypes.func,
    isChallanRevamp: PropTypes.bool,
    regChangeEnabled: PropTypes.bool,
    challanCountData: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    regNumberList: PropTypes.array,
    hideCount: PropTypes.bool
};

export default EChallanRegNo;
